import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Permission } from '@app/models';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { BaseServiceClass } from './baseService.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionService extends BaseServiceClass<any> {
  public findAll(): Observable<Permission[]> {
    return this.http.get<Permission[]>(
      environment.accountUrl + '/api/v1/permissions'
    );
  }

  constructor(private http: HttpClient) {
    super(http, '');
  }
}
